import { MyNewsCompletionConfig } from "./completion/data";
export const MyNewsConfig = {
  completion: MyNewsCompletionConfig
};